<script>
export default {
  name: 'MatchingCard',

  props: {
    settings: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    multiplier() {
      const ratio = Number(this.settings?.matchingRatio || 1);
      return Number((1 + ratio).toFixed(2));
    },
    title() {
      return this.$t('payment.matching.title', { multiplier: this.multiplier });
    }
  }
};
</script>

<template>
  <div v-if="settings && settings.matchingEnabled" class="matching-card">
    <div class="matching-card-title">
      <svg class="matching-card-icon" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
        <path
          d="M5 15.75L10.25 10.5L13.25 13.5L19 7.75M15.5 7.75H19V11.25"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <span>{{ title }}</span>
    </div>
    <p v-if="settings.matchingDescription" class="matching-card-description">
      {{ settings.matchingDescription }}
    </p>
  </div>
</template>
